var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", attrs: { id: "booking-tree-grid" } },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              ref: _vm.searchItemConfigModule,
              attrs: {
                "config-module": _vm.searchItemConfigModule,
                "is-collapse-list": true,
                "grid-options": _vm.gridOptions,
                "is-append-query": true,
                "grid-config-module": "130002",
                reset: true,
                lob: "SI",
                "custom-sim-query-placeholder": _vm.$t(
                  "Message.QuickSearchBusinessNo"
                ),
                "custom-search-items": _vm.customSearchItems,
                "record-expand-status": true,
                "input-enter-query": true
              },
              on: {
                "click-more": function(value) {
                  return (_vm.isAdvancedQuery = value)
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery,
                perConfigChange: function(value) {
                  _vm.perConfigName = value
                },
                refreshGrid: function() {
                  _vm.gridRefreshId += 1
                },
                defaultSearchItemsChange: function(value) {
                  _vm.defaultSearchItems = value
                }
              }
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "1",
                        disabled:
                          !_vm.selectedJob ||
                          _vm.total <= 0 ||
                          _vm.hqDisabledViewDetail ||
                          (!_vm.isHQ && !_vm.validSingleSelect) ||
                          _vm.hierarchyDisabledViewDetail,
                        type: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toLook()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.look")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "2",
                        disabled:
                          !(
                            _vm.selectedJob &&
                            Number(_vm.selectedJob.jobState) === 0 &&
                            !_vm.JobUtils.isBlockJob(_vm.selectedJob)
                          ) ||
                          !_vm.validSingleSelect ||
                          !_vm.hierarchyValidSingleSelect,
                        type: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toEdit()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$checkPermission([
                              "button_SIBooking_addSIBooking"
                            ]) &&
                            !_vm.$checkPermission([
                              "button_Job_importOrderExcel"
                            ]),
                          expression:
                            "$checkPermission(['button_SIBooking_addSIBooking']) && !$checkPermission(['button_Job_importOrderExcel'])"
                        }
                      ],
                      staticStyle: { "margin-right": "5px" },
                      attrs: {
                        no: "3",
                        disabled: _vm.hqDisabledOperate,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toAdd()
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.btn.new")) + " ")]
                  ),
                  _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$checkPermission([
                              "button_SIBooking_addSIBooking"
                            ]) &&
                            _vm.$checkPermission([
                              "button_Job_importOrderExcel"
                            ]),
                          expression:
                            "$checkPermission(['button_SIBooking_addSIBooking']) && $checkPermission(['button_Job_importOrderExcel'])"
                        }
                      ],
                      staticStyle: { margin: "0 5px" },
                      attrs: {
                        no: "exportOrderHandle",
                        disabled: _vm.hqDisabledOperate,
                        "split-button": "",
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.exportOrderHandle()
                        },
                        command: function(p) {
                          _vm.exportOrderCommand = p
                          _vm.exportOrderHandle()
                        }
                      }
                    },
                    [
                      _vm.exportOrderCommand !== _vm.$t("SeaExport.import")
                        ? _c("span", [_vm._v(_vm._s(_vm.exportOrderCommand))])
                        : _vm._e(),
                      _vm.exportOrderCommand === _vm.$t("SeaExport.import")
                        ? _c(
                            "el-upload",
                            {
                              staticStyle: {
                                display: "inline-block",
                                "margin-left": "5px"
                              },
                              attrs: {
                                action: _vm.actionOrderUrl,
                                headers: _vm.headers,
                                "show-file-list": false,
                                accept: ".xls, .xlsx",
                                "before-upload": _vm.beforeOrderUpload,
                                "on-success": _vm.uploadOrderSuccess,
                                data: {
                                  branchId: _vm.$store.getters.currentOfficeId,
                                  lob: "SI"
                                }
                              }
                            },
                            [
                              _c("span", { staticStyle: { color: "white" } }, [
                                _vm._v(_vm._s(_vm.$t("SeaExport.import")))
                              ])
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: _vm.$t("SeaExport.Add") } },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("SeaExport.Add")) + " "
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            { attrs: { command: _vm.$t("SeaExport.import") } },
                            [
                              _c(
                                "el-upload",
                                {
                                  ref: "uploadOrder",
                                  staticStyle: { display: "inline-block" },
                                  attrs: {
                                    action: _vm.actionOrderUrl,
                                    headers: _vm.headers,
                                    "show-file-list": false,
                                    accept: ".xls, .xlsx",
                                    "before-upload": _vm.beforeOrderUpload,
                                    "on-success": _vm.uploadOrderSuccess,
                                    data: {
                                      branchId:
                                        _vm.$store.getters.currentOfficeId,
                                      lob: "SI"
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        "padding-left": "0px",
                                        color: "#6F6F6F",
                                        "text-align": "left",
                                        width: "80px"
                                      },
                                      attrs: { slot: "trigger", type: "text" },
                                      slot: "trigger"
                                    },
                                    [_vm._v(_vm._s(_vm.$t("SeaExport.import")))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: _vm.$t(
                                  "CargoMsg.Cargo_DownImportTemplate"
                                )
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_DownImportTemplate")
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission(["button_deleteSIJob"]),
                          expression: "$checkPermission(['button_deleteSIJob'])"
                        }
                      ],
                      attrs: {
                        no: "4",
                        disabled: !_vm.validMultipleSelect,
                        type: "danger"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toDelete()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_SIBooking_addSIBooking"
                          ]),
                          expression:
                            "$checkPermission(['button_SIBooking_addSIBooking'])"
                        }
                      ],
                      attrs: {
                        no: "5",
                        disabled:
                          !_vm.selectedJob ||
                          !_vm.validSingleSelect ||
                          !_vm.hierarchyValidSingleSelect,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toCopy()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Clone")))]
                  ),
                  _c(
                    "el-upload",
                    {
                      staticStyle: {
                        display: "inline-block",
                        margin: "0 0 0 5px"
                      },
                      attrs: {
                        no: "6",
                        disabled: _vm.hqDisabledOperate,
                        action: _vm.actionUrl,
                        headers: { sessionId: _vm.sessionId },
                        "show-file-list": false,
                        accept: ".csv",
                        "before-upload": _vm.beforeUpload,
                        "on-success": _vm.uploadSuccess
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled: _vm.hqDisabledOperate,
                            type: "primary"
                          },
                          on: { click: _vm.onPayInfoImportClick }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("SeaExport.PaymentInformationImport"))
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.btnInfo.visible.btnPreSubmit,
                          expression: "btnInfo.visible.btnPreSubmit"
                        }
                      ],
                      staticStyle: { "margin-left": "5px" },
                      attrs: {
                        no: "7",
                        disabled:
                          !_vm.validSingleSelect ||
                          !_vm.hierarchyValidSingleSelect,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.doSubmitPrint_PreSubmit()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.PreSubmission")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.btnInfo.visible.btnSubmit,
                          expression: "btnInfo.visible.btnSubmit"
                        }
                      ],
                      attrs: {
                        no: "8",
                        disabled:
                          !_vm.validSingleSelect ||
                          !_vm.hierarchyValidSingleSelect,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.doSubmitPrint_Submit()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Submission")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.btnInfo.visible.btnManagerSubmit,
                          expression: "btnInfo.visible.btnManagerSubmit"
                        }
                      ],
                      attrs: {
                        no: "9",
                        disabled: !_vm.validSingleSelect,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.doSubmitPrint_ManagerSubmit()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ManagerSubmission")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.btnInfo.visible.printReturnOperate,
                          expression: "btnInfo.visible.printReturnOperate"
                        }
                      ],
                      attrs: {
                        no: "10",
                        disabled:
                          !_vm.validSingleSelect ||
                          !_vm.hierarchyValidSingleSelect,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.backReturn(true)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.ReturnAction")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.btnInfo.visible.printReturn,
                          expression: "btnInfo.visible.printReturn"
                        }
                      ],
                      attrs: {
                        no: "11",
                        disabled:
                          !_vm.validSingleSelect ||
                          !_vm.zyHierarchyValidSingleSelect,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.backReturn(false)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.PrintReturn")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "12",
                        disabled: !_vm.validMultipleSelect,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toStatistics()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Statistics")))]
                  ),
                  _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "button_print_batchPrint"
                          ]),
                          expression:
                            "$checkPermission(['button_print_batchPrint'])"
                        }
                      ],
                      staticStyle: { "margin-left": "5px" },
                      attrs: {
                        no: "13",
                        disabled: !_vm.validMultipleSelect,
                        "split-button": "",
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          _vm.onBatchPrint(_vm.$t("SeaExport.BatchPrint"))
                        },
                        command: _vm.onBatchPrint
                      }
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("SeaExport.BatchPrint")) + " "
                      ),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: _vm.$t(
                                  "queryJob.PrintByBusinessNumber"
                                )
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("queryJob.PrintByBusinessNumber"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-dropdown",
                    {
                      staticStyle: { margin: "0 5px", "font-size": "12px" },
                      attrs: { no: "14", disabled: !_vm.validMultipleSelect },
                      on: { command: _vm.batchHandle }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled:
                              !_vm.btnInfo.batchSelectFlag ||
                              !_vm.validMultipleSelect
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("SeaExport.BatchProcessing")) +
                              " "
                          ),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right"
                          })
                        ]
                      ),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _vm.$checkPermission([
                            "button_SIBooking_BatchShutOut"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 23 } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.BatchShutOut"))
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_JobBooking_BatchPerCommit"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 1 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.BatchPreSubmission")
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_JobBooking_BatchCommit"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 2 } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.BatchCommit"))
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_JobBooking_BatchManagerSubmission"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 3 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.BatchManagerSubmission")
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_SIBooking_BatchVessel"
                                ]),
                                command: 27
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.BatchVessel")))]
                          ),
                          _vm.$checkPermission([
                            "button_JobBooking_ReturnToOperater"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    disabled: !_vm.$checkPermission([
                                      "button_JobBooking_ReturnToOperater"
                                    ]),
                                    command: 4
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SeaExport.BatchReturnPreSubmission"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission(["button_JobBooking_Retract"])
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    disabled: !_vm.$checkPermission([
                                      "button_JobBooking_Retract"
                                    ]),
                                    command: 5
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.BatchReturnSubmit")
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_Charge_BatchUnlockReceivable"
                                ]),
                                command: 6
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.BatchUnlockReceivableExpenses"
                                  )
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_Charge_BatchUnlockPayable"
                                ]),
                                command: 7
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.BatchUnlockPayableFees")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_Charge_BatchLockReceivable"
                                ]),
                                command: 8
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.BatchLockingReceivableExpenses"
                                  )
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_Charge_BatchLockPayable"
                                ]),
                                command: 9
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.BatchLockingPayableFees")
                                )
                              )
                            ]
                          ),
                          _vm.$checkPermission([
                            "button_SIBooking_BatchUpdateCustomJobType"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    disabled: !_vm.$checkPermission([
                                      "button_SIBooking_BatchUpdateCustomJobType"
                                    ]),
                                    command: 10
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SeaExport.BatchUpdateCustomJobType"
                                      )
                                    ) + " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_SIBOOKING_BatchUpdateJobInfo"
                                ]),
                                command: 17
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("SeaExport.BatchModifyBusiness"))
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_jobSopTab_BatchReplaceTemplate"
                                ]),
                                command: 18
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "SeaExport.ReplaceSOPTemplatesInBatches"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm.useOrderCenterMode && !_vm.isRegionalCommission
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 19 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "queryJob.BatchInitiateCollaboration"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_JobBooking_BatchFillGpExplain"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 20 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.BatchFillGpExplain")
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_JobBooking_BatchLockJob"
                                ]),
                                command: 21
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_BatchServiceLocking")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                disabled: !_vm.$checkPermission([
                                  "button_JobBooking_BatchUnlockJob"
                                ]),
                                command: 22
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "CargoMsg.Cargo_UnlockServicesInBatches"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm.openMutualTrustConfig
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 24 } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.BatchPushCharges"))
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$checkPermission([
                            "button_JobBooking_ReturnReview"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 28 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_BatchReturnPreApproval"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._l(_vm.instructioinBtns, function(item, index) {
                            return [
                              _c(
                                "el-dropdown-item",
                                {
                                  key: "instruction" + index,
                                  attrs: {
                                    disabled: !item.allowOperate,
                                    command:
                                      "instruction," +
                                      item.tenantInstructionUuid
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$selectByLang(
                                          item.chineseName,
                                          item.englishName,
                                          item.japaneseName
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "15",
                        disabled: !_vm.validMultipleSelect,
                        type: "primary"
                      },
                      on: { click: _vm.editState }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.EditSopStatus")))]
                  ),
                  _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.$checkPermission([
                            "tab_Charge_chargeView"
                          ]),
                          expression:
                            "$checkPermission(['tab_Charge_chargeView'])"
                        }
                      ],
                      staticStyle: { "margin-left": "5px" },
                      attrs: {
                        no: "16",
                        disabled: !_vm.validMultipleSelect,
                        "split-button": "",
                        type: "primary"
                      },
                      on: {
                        click: _vm.chargeHandle,
                        command: function(p) {
                          _vm.chargeCommand = p
                          _vm.chargeHandle()
                        }
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.chargeCommand) + " "),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: { command: _vm.$t("SeaExport.AddCharges") }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.AddCharges")))]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: _vm.$t("SeaExport.EditCharges")
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.EditCharges")))]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: _vm.$t("SeaExport.DeleteCharges")
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.DeleteCharges")))]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: _vm.$t("SeaExport.ChargeImport")
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.ChargeImport")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  !(
                    _vm.$checkPermission(["role_hideAllExports"]) &&
                    !_vm.$store.getters.isAdmin
                  )
                    ? _c(
                        "el-dropdown",
                        {
                          staticStyle: { "margin-left": "5px" },
                          attrs: {
                            no: "17",
                            disabled: !_vm.validMultipleSelect,
                            "split-button": "",
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              return _vm.exportHandle()
                            },
                            command: function(p) {
                              _vm.exportCommand = p
                              _vm.exportHandle()
                            }
                          }
                        },
                        [
                          _vm._v(" " + _vm._s(_vm.exportCommand) + " "),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t("SeaExport.ExportToExcel")
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.ExportToExcel"))
                                  )
                                ]
                              ),
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "SeaExport.ExportWithSOPToExcel"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.ExportWithSOPToExcel")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.toExoSystemYGSH &&
                            _vm.$checkPermission(["button_Charge_ltsSync"]),
                          expression:
                            "toExoSystemYGSH && $checkPermission(['button_Charge_ltsSync'])"
                        }
                      ],
                      staticStyle: { margin: "0 5px", "font-size": "12px" },
                      attrs: { disabled: !_vm.validMultipleSelect },
                      on: { command: _vm.batchLtsSyncHandle }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled:
                              !_vm.btnInfo.batchSelectFlag ||
                              !_vm.validMultipleSelect
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "CargoMsg.Cargo_SynchronousCloudPlatform"
                                )
                              ) +
                              " "
                          ),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right"
                          })
                        ]
                      ),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c("el-dropdown-item", { attrs: { command: 1 } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.receivable")))
                          ]),
                          _c("el-dropdown-item", { attrs: { command: 2 } }, [
                            _vm._v(_vm._s(_vm.$t("SeaExport.payable")))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: { "min-height": "350px" }
            },
            [
              _c("cargo-ag-grid-wrapper", {
                staticStyle: { width: "100%" },
                attrs: {
                  "config-module": "130002",
                  "per-config-name": _vm.perConfigName,
                  "refresh-id": _vm.gridRefreshId,
                  "locale-text-func": _vm._i18nGridLocalText,
                  "grid-options": _vm.gridOptions,
                  "side-bar": {
                    toolPanels: ["columns", "filter"],
                    visible: false
                  },
                  "column-defs": _vm.finalColumnDefs,
                  "row-data": _vm.rowData,
                  "grid-params": _vm.gridParams,
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "show-selected-color": false,
                  "show-row-groups": _vm.dataListDragGroup,
                  "darg-group-show-column-def": _vm.dargGroupShowColumnDef
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  },
                  gridReady: _vm.onGridReady,
                  columnRowGroupChanged: function() {
                    this$1.$refs[_vm.searchItemConfigModule].clickCollapseList()
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.appendQuery && _vm.total > 0,
                    expression: "!appendQuery && total>0"
                  }
                ],
                attrs: {
                  "config-module": "130002",
                  total: _vm.total,
                  "page-count": _vm.pageCount,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize,
                  "selected-row-count": _vm.selectedRowCount
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: function() {
                    if (_vm.total > 0) {
                      _vm.toQuery()
                    }
                  }
                }
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.appendQuery,
                      expression: "appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: { total: _vm.total, layout: "total" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.stateDialog.visible
        ? _c("state-dialog", {
            attrs: {
              visible: _vm.stateDialog.visible,
              rows: _vm.stateDialog.rows,
              "tracking-list": _vm.stateDialog.trackingList
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.stateDialog, "visible", $event)
              },
              callback: function($event) {
                return _vm.toQuery()
              }
            }
          })
        : _vm._e(),
      _vm.shutOutDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "23",
                visible: _vm.shutOutDialog.visible,
                title: _vm.$t("Message.Warning"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.shutOutDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "padding-left": "30px"
                  }
                },
                [
                  _c("span", { staticStyle: { "line-height": "40px" } }, [
                    _vm._v(_vm._s(_vm.$t("Message.PleaseConfirmTheShutOut")))
                  ]),
                  _c("span", { staticStyle: { "line-height": "18px" } }, [
                    _vm._v(_vm._s(_vm.shutOutDialog.shutOutTip1))
                  ]),
                  _c("span", { staticStyle: { "line-height": "18px" } }, [
                    _vm._v(_vm._s(_vm.shutOutDialog.shutOutTip2))
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "24", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.hasChargeShutoutHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.HasChargeToShutOut")))]
                  ),
                  _c(
                    "el-button",
                    {
                      style: { display: _vm.shutOutDialog.shutOutButtonShow2 },
                      attrs: { no: "25", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.noHasChargeShutoutHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.NoChargeToShutOut")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "26" },
                      on: {
                        click: function($event) {
                          _vm.shutOutDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.transshipDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "27",
                visible: _vm.transshipDialog.visible,
                title: _vm.$t("SeaExport.BatchVessel"),
                width: _vm.$selectByLang(
                  "850px",
                  "850px",
                  "850px",
                  "900px",
                  "900px",
                  "900px"
                ),
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.transshipDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c(
                    "el-form",
                    {
                      staticStyle: { "padding-right": "20px" },
                      attrs: {
                        "label-width": "120px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Vessel") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: _vm.clearCheckBox.vessel },
                                model: {
                                  value: _vm.transshipDialog.vessel,
                                  callback: function($$v) {
                                    _vm.$set(_vm.transshipDialog, "vessel", $$v)
                                  },
                                  expression: "transshipDialog.vessel"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange("vessel")
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.vessel,
                                    callback: function($$v) {
                                      _vm.$set(_vm.clearCheckBox, "vessel", $$v)
                                    },
                                    expression: "clearCheckBox.vessel"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PortOfLoading")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "195px" },
                                attrs: {
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  disabled: _vm.clearCheckBox.loadingPortCode,
                                  "default-value":
                                    _vm.transshipDialog.loadingPortCode
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.transshipDialog.loadingPortCode =
                                      p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.ShippingCompany") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "195px" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.carrierId,
                                  filterable: "",
                                  "options-width": "200px;",
                                  "method-params": {
                                    seaCmp: true,
                                    active: true
                                  },
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "default-value":
                                    _vm.transshipDialog.txtCarrierId || ""
                                },
                                on: {
                                  parentCallBack: _vm.onCarrierIdSelectionChange
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "carrierId"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.carrierId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "carrierId",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.carrierId"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.DateOfDeparture2") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "195px" },
                            attrs: {
                              disabled: _vm.clearCheckBox.etd,
                              type: "date",
                              "value-format": "yyyy-MM-dd"
                            },
                            model: {
                              value: _vm.transshipDialog.etd,
                              callback: function($$v) {
                                _vm.$set(_vm.transshipDialog, "etd", $$v)
                              },
                              expression: "transshipDialog.etd"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.ActualDateOfDeparture2")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "195px" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.atd,
                                  type: "date",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.transshipDialog.atd,
                                  callback: function($$v) {
                                    _vm.$set(_vm.transshipDialog, "atd", $$v)
                                  },
                                  expression: "transshipDialog.atd"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange("atd")
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.atd,
                                    callback: function($$v) {
                                      _vm.$set(_vm.clearCheckBox, "atd", $$v)
                                    },
                                    expression: "clearCheckBox.atd"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "120px",
                        "label-position": "left"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Voyage") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.clearCheckBox.voyageFlight
                                },
                                model: {
                                  value: _vm.transshipDialog.voyageFlight,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.transshipDialog,
                                      "voyageFlight",
                                      $$v
                                    )
                                  },
                                  expression: "transshipDialog.voyageFlight"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "voyageFlight"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.voyageFlight,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "voyageFlight",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.voyageFlight"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_PortOfDischarge")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "195px" },
                                attrs: {
                                  disabled:
                                    _vm.clearCheckBox.dischargingPortCode,
                                  filterable: "",
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Seaport,
                                  "default-value":
                                    _vm.transshipDialog.dischargingPortCode
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    _vm.transshipDialog.dischargingPortCode =
                                      p.value
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.BookingAgent") } },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("cargo-advance-select", {
                                staticStyle: { width: "195px" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.bookingAgent,
                                  filterable: "",
                                  "options-width": "200px;",
                                  "method-params": {
                                    bookingAgent: true,
                                    active: true
                                  },
                                  "select-type":
                                    _vm.selectTypeNames.basic_data_Company,
                                  "default-value":
                                    _vm.transshipDialog.txtBookingAgent || ""
                                },
                                on: {
                                  parentCallBack: function(p) {
                                    return (_vm.transshipDialog.txtBookingAgent =
                                      p.cmpIdx)
                                  }
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange(
                                        "bookingAgent"
                                      )
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.bookingAgent,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.clearCheckBox,
                                        "bookingAgent",
                                        $$v
                                      )
                                    },
                                    expression: "clearCheckBox.bookingAgent"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.DateOfArrival2") }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "195px" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.eta,
                                  type: "date",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.transshipDialog.eta,
                                  callback: function($$v) {
                                    _vm.$set(_vm.transshipDialog, "eta", $$v)
                                  },
                                  expression: "transshipDialog.eta"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.ActualDateOfArrival2")
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticStyle: { display: "flex" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "195px" },
                                attrs: {
                                  disabled: _vm.clearCheckBox.ata,
                                  type: "date",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.transshipDialog.ata,
                                  callback: function($$v) {
                                    _vm.$set(_vm.transshipDialog, "ata", $$v)
                                  },
                                  expression: "transshipDialog.ata"
                                }
                              }),
                              _c(
                                "el-checkbox",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  on: {
                                    change: function($event) {
                                      return _vm.clearCheckBoxChange("ata")
                                    }
                                  },
                                  model: {
                                    value: _vm.clearCheckBox.ata,
                                    callback: function($$v) {
                                      _vm.$set(_vm.clearCheckBox, "ata", $$v)
                                    },
                                    expression: "clearCheckBox.ata"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_ClearData"))
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "33", type: "primary" },
                      on: { click: _vm.transShipClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "34" },
                      on: {
                        click: function($event) {
                          _vm.transshipDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.fullSpellTypeDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "35",
                visible: _vm.fullSpellTypeDialog.visible,
                title: _vm.$t("SeaExport.BatchUpdateType"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.fullSpellTypeDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "120px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: {
                        label: _vm.$t("queryJob.BatchOfWholeSplicingType")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "190px" },
                          model: {
                            value: _vm.fullSpellTypeDialog.containerLoadType,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.fullSpellTypeDialog,
                                "containerLoadType",
                                $$v
                              )
                            },
                            expression: "fullSpellTypeDialog.containerLoadType"
                          }
                        },
                        _vm._l(
                          _vm.fullSpellTypeDialog.containerLoadTypes,
                          function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: {
                                label: item.chineseName,
                                value: item.code
                              }
                            })
                          }
                        ),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "36", type: "primary" },
                      on: { click: _vm.fullSpellTypeClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "37" },
                      on: {
                        click: function($event) {
                          _vm.fullSpellTypeDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.statisticsDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                no: "38",
                visible: _vm.statisticsDialog.visible,
                title: _vm.$t("SeaExport.Statistics"),
                width: _vm.$selectByLang("360px", "445px"),
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.statisticsDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-width": _vm.$selectByLang("85px", "170px"),
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Slaves") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "39", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtSlaves,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtSlaves", $$v)
                          },
                          expression: "statisticsDialog.txtSlaves"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Master") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "40", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtMaster,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtMaster", $$v)
                          },
                          expression: "statisticsDialog.txtMaster"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.TotalTickets") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "41", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtCount,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtCount", $$v)
                          },
                          expression: "statisticsDialog.txtCount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.CustomerCount") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "42", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtCustomerCount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtCustomerCount",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtCustomerCount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { label: "20＇" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "43", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txt20,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txt20", $$v)
                          },
                          expression: "statisticsDialog.txt20"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { label: "40＇" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "44", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txt40,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txt40", $$v)
                          },
                          expression: "statisticsDialog.txt40"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { label: "40HQ＇" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "45", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txt40hq,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txt40hq", $$v)
                          },
                          expression: "statisticsDialog.txt40hq"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { label: "45＇" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "46", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txt45,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txt45", $$v)
                          },
                          expression: "statisticsDialog.txt45"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { label: "TEU" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "47", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtTeu,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtTeu", $$v)
                          },
                          expression: "statisticsDialog.txtTeu"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Weight2") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "48", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtWeight,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtWeight", $$v)
                          },
                          expression: "statisticsDialog.txtWeight"
                        }
                      }),
                      _c("span", [_vm._v("KGS")])
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Cubage") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "49", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtCubage,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtCubage", $$v)
                          },
                          expression: "statisticsDialog.txtCubage"
                        }
                      }),
                      _c("span", [_vm._v("CBM")])
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.ChargedWeight") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "50", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtChargeWeight,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtChargeWeight",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtChargeWeight"
                        }
                      }),
                      _c("span", [_vm._v("M/T")])
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.SpecifyAgentNumber") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "51", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtdesignationAgentNum,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtdesignationAgentNum",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtdesignationAgentNum"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { "label-width": "0" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function($event) {
                              return _vm.handleStatistics(true)
                            }
                          },
                          model: {
                            value: _vm.statisticsDialog.containShutOutJob,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.statisticsDialog,
                                "containShutOutJob",
                                $$v
                              )
                            },
                            expression: "statisticsDialog.containShutOutJob"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.ContainShutOutJob")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.statisticsDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.Close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.addChargeDetailDialog.visible
        ? _c("add-charge-detail-dialog", {
            attrs: {
              visible: _vm.addChargeDetailDialog.visible,
              "selected-jobs": _vm.addChargeDetailDialog.selectedJobs,
              "charge-type": _vm.addChargeDetailDialog.type,
              lob: "SI",
              location: _vm.location,
              "selected-scheme": _vm.addChargeDetailDialog.selectedScheme
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.addChargeDetailDialog, "visible", $event)
              },
              toChangeSchema: _vm.toChangeSchema
            }
          })
        : _vm._e(),
      _vm.editChargeDetailDialog.visible
        ? _c("edit-charge-detail-dialog", {
            attrs: {
              visible: _vm.editChargeDetailDialog.visible,
              "selected-jobs": _vm.editChargeDetailDialog.selectedJobs,
              "charge-type": _vm.editChargeDetailDialog.chargeType,
              lob: "SI"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.editChargeDetailDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.deleteChargeDetailDialog.visible
        ? _c("delete-charge-detail-dialog", {
            attrs: {
              visible: _vm.deleteChargeDetailDialog.visible,
              "selected-jobs": _vm.deleteChargeDetailDialog.selectedJobs,
              "charge-type": _vm.deleteChargeDetailDialog.chargeType,
              lob: "SI"
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.deleteChargeDetailDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.chargeSchemeBatchDialog.visible
        ? _c("charge-scheme-batch-dialog", {
            attrs: {
              visible: _vm.chargeSchemeBatchDialog.visible,
              "selected-jobs": _vm.chargeSchemeBatchDialog.selectedJobs,
              job: _vm.chargeSchemeBatchDialog.job,
              "need-check-range": _vm.chargeSchemeBatchDialog.needCheckRange,
              lob: _vm.chargeSchemeBatchDialog.lob,
              "is-sea": _vm.chargeSchemeBatchDialog.isSea,
              "original-condition":
                _vm.chargeSchemeBatchDialog.originalCondition,
              "charge-scheme-is-approved":
                _vm.chargeSchemeBatchDialog.chargeSchemeIsApproved,
              location: _vm.location,
              "charge-type": _vm.chargeSchemeBatchDialog.chargeType,
              source: _vm.chargeSchemeBatchDialog.source
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.chargeSchemeBatchDialog, "visible", $event)
              },
              selectedSchemeHandler: _vm.handleSelectedScheme
            }
          })
        : _vm._e(),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            ref: "batchCheckingWindow",
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              "allow-partial-check-pass":
                _vm.batchCheckingWindow.allowPartialCheckPass,
              lob: _vm.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.checkingWindow.visible
        ? _c("checking-window", {
            attrs: {
              visible: _vm.checkingWindow.visible,
              lob: _vm.lob,
              job: _vm.job,
              "check-node": _vm.checkingWindow.checkNode,
              "call-back": _vm.checkingWindow.callBack,
              "call-back2": _vm.checkingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("lts-batch-sync", {
        ref: "ltsBatchSyncCharge",
        attrs: { visible: _vm.ltsWindow.visible, keys: _vm.ltsWindow.keys },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.ltsWindow, "visible", $event)
          }
        }
      }),
      _c("batch-submit-or-approve-dialog", {
        attrs: {
          visible: _vm.batchSubmitOrApproveDialog.visible,
          "row-data": _vm.batchSubmitOrApproveDialog.rowData,
          "is-submit": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.batchSubmitOrApproveDialog, "visible", $event)
          }
        }
      }),
      _c("batch-modify-business-dialog", {
        attrs: {
          visible: _vm.batchModifyBusinessDialog.visible,
          "job-keys": _vm.batchModifyBusinessDialog.jobKeys,
          "job-list": _vm.batchModifyBusinessDialog.jobList,
          lob: _vm.batchModifyBusinessDialog.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.batchModifyBusinessDialog, "visible", $event)
          },
          callback: _vm.batchModifyBusinessCallback
        }
      }),
      _c("change-sop-template-dialog", {
        attrs: {
          visible: _vm.changeSopTemplateDialog.visible,
          lob: _vm.lob,
          "job-list": _vm.changeSopTemplateDialog.jobList
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.changeSopTemplateDialog, "visible", $event)
          },
          reload: _vm.reload
        }
      }),
      _c("batch-cooperation-dialog", {
        attrs: {
          visible: _vm.batchCooperationDialog.visible,
          "job-list": _vm.batchCooperationDialog.jobList,
          "order-center-branch": _vm.orderCenterBranch
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.batchCooperationDialog, "visible", $event)
          }
        }
      }),
      _c("download-import-template-dialog", {
        attrs: {
          visible: _vm.downloadImportTemplateDialog.visible,
          lob: _vm.downloadImportTemplateDialog.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.downloadImportTemplateDialog, "visible", $event)
          }
        }
      }),
      _vm.workFlowApplyDialog.visible
        ? _c("job-work-flow-apply-dialog", {
            attrs: {
              visible: _vm.workFlowApplyDialog.visible,
              title: _vm.$t("CargoMsg.Cargo_Approving"),
              "process-info": _vm.workFlowApplyDialog.documentProcess,
              records: _vm.workFlowApplyDialog.approvalCommentsRecords,
              type: "approve",
              "doc-id": _vm.workFlowApplyDialog.documentProcess.docId,
              "document-config-id":
                _vm.workFlowApplyDialog.documentProcess.documentConfigId
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.workFlowApplyDialog, "visible", $event)
              },
              close: function($event) {
                _vm.workFlowApplyDialog.visible = false
              },
              closeAndRefresh: function() {
                _vm.workFlowApplyDialog.visible = false
                _vm.toQuery()
              }
            }
          })
        : _vm._e(),
      _vm.gpExplain.visible
        ? _c("add-gp-explain-dialog", {
            attrs: {
              type: _vm.gpExplain.type,
              visible: _vm.gpExplain.visible,
              "job-uuids": _vm.gpExplain.jobUuids
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.gpExplain, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.customJobTypeDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.customJobTypeDialog.visible,
                title: _vm.$t("SeaExport.BatchUpdateCustomJobType"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.customJobTypeDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "120px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.CustomJobType") + ":" }
                    },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          "select-type":
                            _vm.selectTypeNames.basic_data_CutomJobType,
                          filterable: "",
                          "method-params": {
                            type: _vm.SystemConstants.SI.code,
                            active: true
                          },
                          "default-value": _vm.customJobTypeDialog.customJobType
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.customJobTypeDialog.customJobType = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.customJobTypeClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.customJobTypeDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("job-return-review-dialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.returnReviewDialog.visible,
            expression: "returnReviewDialog.visible"
          }
        ],
        attrs: {
          visible: _vm.returnReviewDialog.visible,
          lob: "SI",
          "selected-jobs": _vm.returnReviewDialog.selectedJobs,
          srouce: "list"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.returnReviewDialog, "visible", $event)
          },
          confirm: function($event) {
            return _vm.toQuery()
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.chargeTypeDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_AddCostType"),
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.chargeTypeDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { margin: "30px 30px" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.chargeTypeDialog.type,
                    callback: function($$v) {
                      _vm.$set(_vm.chargeTypeDialog, "type", $$v)
                    },
                    expression: "chargeTypeDialog.type"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Receivable")))
                  ]),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Dues")))
                  ]),
                  _c("el-radio", { attrs: { label: 0 } }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ARAP")))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onChargeTypeDialogConfirm }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.chargeTypeDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("tenant-entrust-window", {
        ref: "tenantEntrustWindow",
        on: { instructionCallback: _vm.onInstructionCallback }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }